import React from 'react';

import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './loading.component.module.styl';

import type {ComponentProps} from 'react';


export const Types = {
    NONE: 'NONE',
    ICON: 'ICON',
    FIELD_ICON: 'FIELD_ICON',
} as const;

const classNames = withCssModule(styles);

type LoadingType = keyof typeof Types;

type NativeSpanProps = ComponentProps<'span'>;

export interface Props extends NativeSpanProps {
    /**
     * Loading show without delay
     * */
    fast?: boolean,

    /**
     * Loading style type
     * */
    type?: LoadingType,

    /**
     * Custom classes
     * @deprecated It will be removed in 6 months 09-20-2025. use className instead
     */
    mix?: string,

    /**
     * Apply dark mode styles
     */
    darkMode?: boolean,
}

/**
 * @see [Storybook]{@link https://storybook.dev.pitchbookdata.com/?path=/story/components-loading-loading}
 */
export function Loading(props: Props) {
    const {
        className,
        fast = false,
        mix,
        darkMode = false,
        role = 'progressbar',
        type = Types.NONE,
        ...restProps
    } = props;

    const loadingProps = {
        ...restProps,
        role,
        className: classNames('loading', mix, className, {
            'loading_fast': fast,
            'loading_icon': type === Types.ICON,
            'loading_field-icon': type === Types.FIELD_ICON,
            'loading_dark-mode': darkMode,
        }),
    };

    return <span {...loadingProps}/>;
}
